import { SwapState } from '@/domain/swap';
import SwapSummary from './SwapSummary';
import { UseSwapDataReturn } from '@/application/read/swap/useSwapData';
import { Chain } from 'viem';
import { useSettings } from '@/presentation/context/settings';
import { useProvider } from '@nftx/react';
import { useQuery } from '@tanstack/react-query';
import { getTotalTokenIds } from 'nftx.js';
import { QueryKey } from '@/application/queryKeys';

type Props = SwapState &
  UseSwapDataReturn & {
    chain: Chain;
  };

const SwapSummaryContainer = ({
  source,
  buySymbol,
  sellSymbol,
  buyType,
  sellType,
  quote,
  chain,
  ...props
}: Props) => {
  const provider = useProvider();
  const { data: gasPrice = 0n } = useQuery([QueryKey.GAS_PRICE, provider], () =>
    provider.getGasPrice()
  );
  const [{ slippage }] = useSettings();
  const buyAmount =
    buyType === 'NFT'
      ? getTotalTokenIds(props.buyItems)
      : Number(props.buyAmount);
  const sellAmount =
    sellType === 'NFT'
      ? getTotalTokenIds(props.sellItems)
      : Number(props.sellAmount);

  return (
    <SwapSummary
      buyAmount={buyAmount}
      buySymbol={buySymbol}
      sellAmount={sellAmount}
      sellSymbol={sellSymbol}
      quote={quote}
      slippage={slippage}
      gasPrice={gasPrice}
    />
  );
};

export default SwapSummaryContainer;
